import { db } from "../firebase";

export const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const getClickableLink = (link) => {
  return link.startsWith("http://") || link.startsWith("https://")
    ? link
    : `http://${link}`;
};

export const getAllMentors = () => {
  return new Promise((resolve, reject) => {
    db.collection("mentors")
      .where("status", "==", true)
      .get()
      .then((snapshot) => {
        resolve(snapshot.docs.map((doc) => doc.data()));
      })
      .catch((error) => {
        reject(error);
        console.log("Error getting documents: ", error);
      });
  });
};
